import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormGroupComponent, FormGroupControlInput} from './form-group.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [FormGroupComponent, FormGroupControlInput],
  exports: [FormGroupComponent, FormGroupControlInput]
})
export class FormGroupModule { }
